export default __webpack_public_path__ + "static/media/biking_.8d66eccb.jpeg";